import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PostMealItemEntity } from '../../domain/entities/PostMealItemEntity'
import { MealItemSelectionModel } from './MealItemSelectionModel'
import type { MealItemSelectionAdminRequest } from '@/backend/market'

export class PostMealItemModel extends PostMealItemEntity {
  declare mealId: string
  userId!: string
  declare itemId: number
  declare quantity: number

  declare selections: Array<MealItemSelectionAdminRequest>
  constructor(dataDto: PostMealItemEntity) {
    super()
    const mealItemSelectionModel = dataDto.selections?.map(
      (selection) => new MealItemSelectionModel(selection)
    )
    mapEntityProperties<PostMealItemModel>(this, dataDto, {
      exclude: ['user'],
      map: {
        selections: mealItemSelectionModel,
        userId: dataDto.user?.userId
      }
    })
  }
}
